import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from "@chakra-ui/react";
import { GlassSurface } from "./GlassSurface";
import { GlassModalOverlay } from "./GlassModalContent";
import { glassContentSx } from "@/theme/glassSx";

/**
 * Unified glass dialog: white translucent sheet, dark ink typography.
 */
export default function AppModal({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = "md",
  variant = "solid",
  isCentered = true,
  scrollBehavior = "inside",
  hideCloseButton = false,
  ...props
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      isCentered={isCentered}
      scrollBehavior={scrollBehavior}
      motionPreset="slideInBottom"
    >
      <GlassModalOverlay />
      <ModalContent
        bg="transparent"
        boxShadow="none"
        color="text.onGlass"
        mx={{ base: 3, md: 4 }}
        sx={glassContentSx}
        {...props}
      >
        <GlassSurface variant={variant} p={0} overflow="hidden">
          {title && (
            <ModalHeader
              borderBottom="1px solid"
              borderColor="blackAlpha.100"
              pr={12}
              fontSize={{ base: "lg", md: "xl" }}
            >
              {title}
              {subtitle}
            </ModalHeader>
          )}
          {!hideCloseButton && (
            <ModalCloseButton
              color="gray.600"
              _hover={{ bg: "blackAlpha.100", color: "gray.800" }}
            />
          )}
          <ModalBody py={5}>{children}</ModalBody>
          {footer && (
            <ModalFooter
              borderTop="1px solid"
              borderColor="blackAlpha.100"
              gap={3}
              flexWrap="wrap"
            >
              {footer}
            </ModalFooter>
          )}
        </GlassSurface>
      </ModalContent>
    </Modal>
  );
}
